import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import Axios from "axios";
import { api } from "../utils/api";
import Modal from "./Modal";
import Checkbox from "./Checkbox";
import AppNotice from "./AppNotice";
import { isOlderVersion } from "../utils/appVersion";

/**
 * 예전 홈(Main)에 있던 기능을 새 홈에도 (2026-10 전체 공개 때 옮김):
 * 관리자 공지 팝업(오늘 하루 보지 않기) · 하루 한 번 방문 수 세기 · 옛 앱 업데이트 요청 · 앱 안내.
 */
const ua = navigator.userAgent;

const exitApp = () => {
  if (ua.match("chordscore/Android") != null) {
    window.chordscore.postMessage(JSON.stringify({ type: "back" }));
  } else if (ua.match("chordscore/iOS") != null) {
    window.webkit.messageHandlers.exitHandler.postMessage("_");
  }
};

const HomeExtras: React.FC = () => {
  const [popup, setPopup] = useState<any>(null);
  const [open, setOpen] = useState(false);
  const [skipToday, setSkipToday] = useState(false);
  const [update, setUpdate] = useState(false);

  // 공지 팝업 (오늘 하루 보지 않기를 눌렀으면 오늘은 안 띄움)
  useEffect(() => {
    const t = setTimeout(async () => {
      try {
        const closed = localStorage.getItem("checkClosePopup");
        if (closed && new Date(closed).toDateString() === new Date().toDateString()) return;
        const { data } = await api.get("/popup/index");
        setPopup(data);
        setOpen(!!(data && data.active && (data.image_url_1 || data.image_url_2)));
      } catch (e) {}
    }, 1000);
    return () => clearTimeout(t);
  }, []);

  // 하루 한 번 방문 수 (예전 홈과 같은 쿠키)
  useEffect(() => {
    if (!document.cookie.match("(^|;) ?choardmc=([^;]*)(;|$)")) {
      api.post("/main/count").catch(() => {});
      const d = new Date(Date.now() + 24 * 60 * 60 * 1000);
      document.cookie = "choardmc=choardmc;expires=" + d.toUTCString() + ";path=/;Secure;SameSite=None";
    }
  }, []);

  // 옛 앱이면 업데이트 요청 (설정 파일의 최신 버전과 비교)
  useEffect(() => {
    const isAndroid = ua.match("chordscore/Android") != null;
    const iosMatch = ua.match(/AppBuildVersionIOS\/(\S+)/);
    if (!(isAndroid && window.chordscore?.android) && !(ua.match("chordscore/iOS") && iosMatch)) return;
    Axios.get("https://s3.ap-northeast-2.amazonaws.com/chordscore.com/setting.json")
      .then((res) => {
        const s = res.data?.data;
        if (!s || s.maintenance) return;
        if (isAndroid ? isOlderVersion(window.chordscore.android, s.version?.android) : isOlderVersion(iosMatch![1], s.version?.ios)) setUpdate(true);
      })
      .catch(() => {});
  }, []);

  const close = () => {
    if (skipToday) localStorage.setItem("checkClosePopup", new Date().toUTCString());
    setOpen(false);
  };
  const count = (order: number) => api.post("/popup/count", { id: popup?.id, order }).catch(() => {});

  return (
    <>
      {update && (
        <Modal
          open={update}
          onClose={exitApp}
          firstButtonLabel="종료"
          onClickFirstButton={exitApp}
          title="업데이트 요청"
          content={
            <>
              사용하시는 버전이 구 버전입니다.
              <br />
              업데이트 후 이용 부탁드립니다.
            </>
          }
        />
      )}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        width={560}
        content={
          <>
            <Images>
              {popup?.image_url_1 && (
                <a href={popup.link_url_1} target="blank" onClick={() => count(1)}>
                  <Img src={popup.image_url_1} alt="" />
                </a>
              )}
              {popup?.image_url_2 && (
                <a href={popup.link_url_2} target="blank" onClick={() => count(2)}>
                  <Img src={popup.image_url_2} alt="" />
                </a>
              )}
            </Images>
            <Foot>
              <Checkbox name="checkClosePopup" type="checkbox" checked={skipToday} onChange={() => setSkipToday(!skipToday)}>
                오늘하루 보지 않기
              </Checkbox>
              <button type="button" onClick={close}>닫기</button>
            </Foot>
          </>
        }
      />
      <AppNotice />
    </>
  );
};

export default HomeExtras;

const Images = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  & > a {
    flex: 1;
    min-width: 0;
  }
`;

const Img = styled.img`
  display: block;
  width: 100%;
  aspect-ratio: 3 / 4;
  object-fit: cover;
  border-radius: 8px;
`;

const Foot = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  & > button {
    border: 0;
    background: none;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
  }
`;
